import type { AfterViewInit } from '@angular/core';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ImageComponent } from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { ComposableCardComponent } from '../../../composables/card/card.component';
import { BasicContentPartialTopBetweenComponent } from '../../partials/basic-content-partial-top-between/basic-content-partial-top-between.component';

@Component({
  selector: 'wl-basic-content-variant-vertical-image',
  templateUrl: './basic-content-variant-vertical-image.component.html',
  styleUrls: [
    './basic-content-variant-vertical-image.component.ed.scss',
    './basic-content-variant-vertical-image.component.essent.scss',
  ],
  standalone: true,
  imports: [
    ComposableCardComponent,
    NgTemplateOutlet,
    BasicContentPartialTopBetweenComponent,
    ImageComponent,
    JssModule,
  ],
})
export class BasicContentVariantVerticalImageComponent
  extends BasicContentVariantInheritableComponent
  implements AfterViewInit
{
  @ViewChild('imageRef') imageRef?: ElementRef;
  imageHeight?: number;

  constructor(private readonly renderer: Renderer2) {
    super();
  }

  ngAfterViewInit() {
    this.setImageHeight();
  }

  setImageHeight() {
    if (this.imageRef) {
      if (this.image?.aspectRatio) {
        const [widthRatio, heightRatio] = this.image?.aspectRatio
          .split('/')
          .map((v) => parseInt(v));
        const width = this.imageRef.nativeElement.offsetWidth;
        if (widthRatio >= heightRatio) {
          this.renderer.setStyle(
            this.imageRef.nativeElement,
            'height',
            `${(width / widthRatio) * heightRatio}px`
          );
        }
      } else {
        this.renderer.addClass(this.imageRef.nativeElement, 'h-100');
      }
    }
  }
}
